export const appTypeTranslate = {
  all: "Todas",
  "web.sentry": "Área Web",
  mobileabordagem: "App Sentry Abordagem",
  monitoramento: "App Sentry Alarmes",
  mobiledespacho: "App Sentry Despacho",
  mobileagent: "App Sentry Agente",
  sentryview: "SentryView",
}


export const appType = Object.entries(appTypeTranslate).map(([key, value]) => ({value: key, label: value}));